<div class="db-wrap">

  <!-- KPI row -->
  <div class="db-kpis">
    <div class="db-card db-kpi">
      <span class="db-label">Kunjungan Hari Ini</span>
      <span class="db-num">{{kpi.visitsToday}}</span>
      <span class="db-kpi-foot">
        <span class="db-delta" [class.up]="kpi.visitUp" [class.down]="!kpi.visitUp" *ngIf="kpi.visitDelta">
          <svg *ngIf="kpi.visitUp" viewBox="0 0 10 10" fill="currentColor"><path d="M5 1l4 5H1z"/></svg>
          <svg *ngIf="!kpi.visitUp" viewBox="0 0 10 10" fill="currentColor"><path d="M5 9L1 4h8z"/></svg>
          {{kpi.visitDelta}}%</span>
        <span *ngIf="kpi.visitDelta">vs kemarin</span>
      </span>
    </div>

    <div class="db-card db-kpi">
      <span class="db-label">Total Pengguna</span>
      <span class="db-num">{{kpi.user}}</span>
      <span class="db-kpi-foot">
        <span class="db-delta up" *ngIf="kpi.userDelta">
          <svg viewBox="0 0 10 10" fill="currentColor"><path d="M5 1l4 5H1z"/></svg>{{kpi.userDelta}}%</span>
        <span *ngIf="kpi.userDelta">vs 1 bulan lalu</span>
      </span>
    </div>

    <div class="db-card db-kpi">
      <span class="db-label">Langganan Aktif</span>
      <div class="db-subs-line">
        <span class="db-num">{{kpi.subs}}</span>
        <div class="db-subs-legend">
          <span title="Voucher"><i style="background:#1761fd"></i><b>{{kpi.subsVoucher}}</b></span>
          <span title="Play Store"><i style="background:#d89e30"></i><b>{{kpi.subsPlay}}</b></span>
          <span title="App Store"><i style="background:#db4a68"></i><b>{{kpi.subsApp}}</b></span>
        </div>
        <div class="db-subs-pie" id="subsPie" role="img"
             aria-label="Komposisi langganan aktif per sumber"></div>
      </div>
      <span class="db-kpi-foot">
        <span class="db-delta" [class.up]="kpi.subsUp" [class.down]="!kpi.subsUp" *ngIf="kpi.subsDelta"
              title="Aktivasi 1 bulan terakhir dibanding 1 bulan sebelumnya">
          <svg *ngIf="kpi.subsUp" viewBox="0 0 10 10" fill="currentColor"><path d="M5 1l4 5H1z"/></svg>
          <svg *ngIf="!kpi.subsUp" viewBox="0 0 10 10" fill="currentColor"><path d="M5 9L1 4h8z"/></svg>
          {{kpi.subsDelta}}%</span>
        <span *ngIf="kpi.subsDelta">vs 1 bulan lalu</span>
      </span>
    </div>

    <div class="db-card db-kpi">
      <span class="db-label">Donasi SahamQu</span>
      <span class="db-num db-num-sm">{{kpi.sahamqu}}</span>
      <span class="db-kpi-foot">
        <span class="db-delta" [class.up]="kpi.sahamquUp" [class.down]="!kpi.sahamquUp" *ngIf="kpi.sahamquDelta"
              title="1 bulan terakhir dibanding 1 bulan sebelumnya">
          <svg *ngIf="kpi.sahamquUp" viewBox="0 0 10 10" fill="currentColor"><path d="M5 1l4 5H1z"/></svg>
          <svg *ngIf="!kpi.sahamquUp" viewBox="0 0 10 10" fill="currentColor"><path d="M5 9L1 4h8z"/></svg>
          {{kpi.sahamquDelta}}%</span>
        <span *ngIf="kpi.sahamquDelta">vs 1 bulan lalu &middot; {{kpi.sahamquTrx}} transaksi</span>
        <span *ngIf="!kpi.sahamquDelta">{{kpi.sahamquTrx}} transaksi berhasil</span>
      </span>
    </div>
  </div>

  <!-- main: daily visits + gender -->
  <div class="db-main">
    <div class="db-card">
      <div class="db-card-h">
        <span class="t">Kunjungan Harian</span>
        <span class="d">Pengunjung unik per hari &middot; Diperbarui {{isUpdatedVw}}</span>
        <span class="sp"></span>
        <div class="db-seg" role="tablist" aria-label="Rentang waktu">
          <button type="button" [class.on]="isRange == 7" (click)="setRange(7)">7 Hari</button>
          <button type="button" [class.on]="isRange == 30" (click)="setRange(30)">30 Hari</button>
          <button type="button" [class.on]="isRange == 90" (click)="setRange(90)">90 Hari</button>
        </div>
      </div>
      <div class="db-chart">
        <div class="db-loading" *ngIf="isChartLoading">
          <img src="assets/images/preloaders/3.svg" alt="Memuat data">
        </div>
        <div id="visitChart" role="img" [attr.aria-label]="'Grafik kunjungan harian ' + isRange + ' hari terakhir'"></div>
      </div>
    </div>

    <div class="db-card">
      <div class="db-card-h">
        <span class="t">Jenis Kelamin</span>
        <span class="d">Seluruh pengguna</span>
      </div>
      <div class="db-donut-wrap">
        <div class="db-donut">
          <div id="genderDonut" role="img" aria-label="Komposisi jenis kelamin pengguna"></div>
          <div class="mid">
            <b>{{genderTotal}}</b>
            <span class="db-label">Pengguna</span>
          </div>
        </div>
        <div class="db-legend">
          <div class="lg-row" *ngFor="let g of genderRows">
            <span class="dot" [style.background]="g.color"></span>
            <span class="name">{{g.label}}</span>
            <span class="val">{{g.value}}</span>
            <span class="pct">{{g.pct}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- bottom: content + subscriptions -->
  <div class="db-duo">
    <div class="db-card">
      <div class="db-card-h">
        <span class="t">Konten Aplikasi</span>
        <span class="d">Total terpasang</span>
      </div>
      <div class="db-clist">
        <div class="c-row">
          <span class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 8h6a4 4 0 014 4v9a3 3 0 00-3-3H2z"/><path d="M22 8h-6a4 4 0 00-4 4v9a3 3 0 013-3h7z"/><path d="M10 5.4a3 3 0 014 0"/><path d="M8.2 3.2a5.8 5.8 0 017.6 0"/></svg></span>
          <span class="name"><span class="n">Audio Murottal</span><span class="s">File audio per ayat</span></span>
          <span class="val">{{content.audio}}</span>
        </div>
        <div class="c-row">
          <span class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h13M3 12h13M3 18h8"/><path d="M16 14.5v7l5.5-3.5z"/></svg></span>
          <span class="name"><span class="n">Hafalan</span><span class="s">Target dibuat pengguna</span></span>
          <span class="val">{{content.hafalan}}</span>
        </div>
        <div class="c-row">
          <span class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg></span>
          <span class="name"><span class="n">Konten Feed</span><span class="s">Postingan foto</span></span>
          <span class="val">{{content.feed}}</span>
        </div>
        <div class="c-row">
          <span class="ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="3"/><path d="M10 9l5 3-5 3z"/></svg></span>
          <span class="name"><span class="n">Konten Video</span><span class="s">Tautan YouTube</span></span>
          <span class="val">{{content.video}}</span>
        </div>
      </div>
    </div>

    <div class="db-card">
      <div class="db-card-h">
        <span class="t">Langganan</span>
        <span class="d">Komposisi sumber langganan</span>
      </div>
      <div class="db-bars" *ngIf="bars">
        <div class="b-row">
          <div class="b-top">
            <span class="b-name"><span class="dot" style="background:#1761fd"></span>Voucher</span>
            <span class="sp"></span>
            <span class="b-val">{{bars.voucher.value}}</span>
            <span class="b-pct">{{bars.voucher.pct | number:'1.1-1'}}%</span>
          </div>
          <div class="b-track"><div class="b-fill" [style.width.%]="bars.voucher.pct" style="background:#1761fd"></div></div>
        </div>
        <div class="b-row">
          <div class="b-top">
            <span class="b-name"><span class="dot" style="background:#d89e30"></span>Play Store</span>
            <span class="sp"></span>
            <span class="b-val">{{bars.play.value}}</span>
            <span class="b-pct">{{bars.play.pct | number:'1.1-1'}}%</span>
          </div>
          <div class="b-track"><div class="b-fill" [style.width.%]="bars.play.pct" style="background:#d89e30"></div></div>
        </div>
        <div class="b-row">
          <div class="b-top">
            <span class="b-name"><span class="dot" style="background:#db4a68"></span>App Store</span>
            <span class="sp"></span>
            <span class="b-val">{{bars.appstore.value}}</span>
            <span class="b-pct">{{bars.appstore.pct | number:'1.1-1'}}%</span>
          </div>
          <div class="b-track"><div class="b-fill" [style.width.%]="bars.appstore.pct" style="background:#db4a68"></div></div>
        </div>
        <div class="b-note">
          Total <b>{{bars.total}}</b> langganan &middot; Rata-rata <b>{{bars.weeklyAvg}}</b> aktivasi baru per minggu dalam 30 hari terakhir.
        </div>
      </div>
    </div>
  </div>


  <!-- app usage: from the app's request headers (app_usage_daily, 90 days) -->
  <div class="db-card">
    <div class="db-card-h">
      <span class="t">Penggunaan Aplikasi</span>
      <span class="d" *ngIf="usage && !usage.empty">{{usage.devices}} perangkat &middot; {{usage.users}} pengguna masuk &middot; {{isRange}} hari terakhir</span>
    </div>
    <div class="db-bars" *ngIf="!usage">
      <span class="b-note">Memuat&hellip;</span>
    </div>
    <div class="db-bars" *ngIf="usage && usage.empty">
      <span class="b-note" *ngIf="!usage.failed">Belum ada data. Data muncul setelah pengguna memakai versi aplikasi yang mengirim informasi perangkat dan wilayah.</span>
      <span class="b-note" *ngIf="usage.failed">Gagal memuat data penggunaan.</span>
    </div>
    <div class="db-usage" *ngIf="usage && !usage.empty">
      <div class="db-bars" *ngFor="let g of usage.groups">
        <span class="db-label">{{g.title}}</span>
        <div class="b-row" *ngFor="let r of g.rows">
          <div class="b-top">
            <span class="b-name">{{r.name}}</span>
            <span class="sp"></span>
            <span class="b-val">{{r.value}}</span>
            <span class="b-pct">{{r.pct | number:'1.1-1'}}%</span>
          </div>
          <div class="b-track"><div class="b-fill" [style.width.%]="r.pct" style="background:#1761fd"></div></div>
        </div>
      </div>
    </div>
  </div>

</div>
